<template>
	<v-card flat outlined>
		<v-card-title>Select a delivery address</v-card-title>
		<v-card-text
			><v-data-table
				v-model="selectedItem"
				:headers="tableHeaders"
				:items="deliveryAddresses"
				item-key="addressId"
				dense
				disable-sort
				hide-default-footer
				single-select
				show-select
				v-on:item-selected="onAddressSelected"
			/>
		</v-card-text>
	</v-card>
</template>

<script>
	import { mapGetters } from "vuex";
	export default {
		name: "OrderDeliveryForm",
		computed: {
			...mapGetters({
				cart: "shoppingCart/cart",
				deliveryAddresses: "account/deliveryAddresses",
			}),
		},
		data() {
			return {
				selectedItem: [],
				transportTypeItems: "['SHIP', 'COLLECT']",
				tableHeaders: [
					{ text: "addressType", value: "addressType" },
					{ text: "attentionTo", value: "attentionTo" },
					{
						text: "streetNameAndNumber",
						value: "streetNameAndNumber",
					},
					{ text: "zipCode", value: "zipCode" },
					{ text: "city", value: "city" },
					{ text: "countryCode", value: "countryCode" },
					{ text: "addressId", value: "addressId" },
				],
			};
		},
		methods: {
			onChangeTransportType() {
				let params = {};
				params.transportType = this.cart.transportType;
				this.$store.dispatch("shoppingCart/setTransportType", params);
			},
			onAddressSelected(pSelected) {
				var x = null;
				if (pSelected.value === true) {
					x = pSelected.item.addressId;
				}

				this.$store.dispatch("shoppingCart/setDeliveryAddressId", x);
			},
		},
	};
</script>

